export enum Images {
  //DEMO PURPOSES
  ADIDAS_LOGO = require('~assets/images/adidas_logo.png'),

  BRAND_LOGO_PLACEHOLDER = require('~assets/images/brand_placeholder.png'),
  EMPTY_OFFER = require('~assets/images/empty_offers.png'),
  LOGO = require('~assets/images/logo.png'),
  LOGO_ANIMATION = require('~assets/images/logo_animation.gif'),
  R_LOGO_WITH_NAME = require('~assets/images/r_logo_with_name.png'),
  OFFER_IMAGE_PLACEHOLDER = require('~assets/images/offer_image_placeholder.jpeg'),
  POINTS_INDICATOR_BG = require('~assets/images/points_indicator_bg.png'),
  ROCKET_FUEL_LOGO = require('~assets/images/logo.png'),
  ROCKETFUEL_CIRCULAR = require('~assets/images/rocketfuel-circular.png'),
  SYGNET = require('~assets/images/sygnet.png'),
}
export enum Images_Demo {
  BITCOIN_3 = require('~assets/assets_demo/bitcoin3.png'),
  BITCOIN_4 = require('~assets/assets_demo/bitcoin4.png'),
  LOGO_ADIDAS = require('~assets/assets_demo/logo_adidas.png'),
  LOGO_DOUGLAS = require('~assets/assets_demo/logo_douglas.png'),
  NFT_OCTOPUS = require('~assets/assets_demo/NFT_octopus.png'),
  NFT_TURTLE = require('~assets/assets_demo/NFT_turtle.png'),
  NFT_PLACEHOLDER = require('~assets/assets_demo/NFT_placeholder.png'),
  PARFUME = require('~assets/assets_demo/parfume.png'),
  SHOES = require('~assets/assets_demo/shoes.png'),
}
